import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Contact } from '@ztechapps/common.contract'
import { HaulerLogo } from './HaulerLogo'

@ObjectType()
export class MilkPickupDriverRef {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string

  @Field(() => HaulerLogo, { nullable: true })
  @Prop({ type: HaulerLogo })
  logo?: ReturnType<() => HaulerLogo>

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>
}
